/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';

export const updateUserPreferences = createAction<Record<string, unknown>>(
  'user/UPDATE_USER_PREFERENCES',
);
